import React from 'react';

const BlockUIContext = React.createContext({});

export default BlockUIContext;
